import { Injectable } from '@angular/core'
import { AccountControllerService, SignalRAdminService, SignalRUserService } from 'app/shared/generated/generated'
import { BehaviorSubject, map } from 'rxjs'
import { AuthenticationControllerService, CurrentAuthenticatedUserDto } from '../generated/generated'
import { RoleConstants } from './../generated/generated'

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  constructor(
    private authenticationControllerService: AuthenticationControllerService,
    private accountControllerService: AccountControllerService,
    private signalRUserService: SignalRUserService,
    private signalRAdminService: SignalRAdminService
  ) {
    if (this.user$.getValue()) {
      this.registerSignalREvents()
    }
  }

  public isAuthorized$ = new BehaviorSubject(false)
  public user$ = new BehaviorSubject(this.getSessionUser())

  public signOut() {
    this.accountControllerService.logout_get().subscribe((data) => {
      this.isAuthorized$.next(false)
      window.location.href = data.result.message
    })
  }

  public isUserAuthorized() {
    return this.authenticationControllerService.isCurrentUserAuthenticated_get().pipe(
      map((data) => {
        let isUserAuthorized = data.succeeded ? data.result : false
        this.isAuthorized$.next(isUserAuthorized)
        return isUserAuthorized
      })
    )
  }

  public getCurrentlyAuthorizedUser() {
    return this.accountControllerService.getCurrentlyAuthorizedUser_get().pipe(
      map((data) => {
        if (data.succeeded) {
          this.updateSessionUser(data.result)
          return this.user$.value
        } else {
          this.updateSessionUser(null)
        }
      })
    )
  }

  public clearUserSessionData() {
    localStorage.removeItem('you')
    this.user$.next(null)
  }

  private updateSessionUser(data: CurrentAuthenticatedUserDto) {
    // let currentUserValue = this.user$.getValue()
    if (JSON.stringify(data) != localStorage.getItem('you')) {
      localStorage.setItem('you', JSON.stringify(data))
      this.user$.next(data)
    }
  }

  private getSessionUser() {
    return JSON.parse(localStorage.getItem('you')) as unknown as CurrentAuthenticatedUserDto
  }

  public registerSignalREvents() {
    this.signalRUserService.notifyUserOfAccountUpdate_register(() => {
      this.accountControllerService.getCurrentlyAuthorizedUserFromDatabase_get().subscribe((data) => {
        this.updateSessionUser(data.result)
      })
    })

    this.user$.subscribe((data) => {
      if (data && data.roles && data.roles.length > 0 && !this.signalRAdminService.hasRemoteConnection) {
        if (data.roles.includes(RoleConstants.admin)) {
          this.signalRAdminService.connect_register(() => {})
        }
      }
    })
  }
}
